import { useLiveApp } from '../context/LiveAppContext';
import { OrgChart } from './OrgChart';
import { GapDashboard } from './GapDashboard';
import { HierarchicalScorecard } from './HierarchicalScorecard';

export default function SimpleDashboard() {
 const { orgChart, authState, currentView, setCurrentView, logout } = useLiveApp();

 const isAdmin = authState.user?.role === 'admin';

 const exportOrgChartData = () => {
  const orgChartDataContent = `import { OrgChartData, OrgChartPerson } from '../types/scorecard';

export const initialOrgChartData: OrgChartPerson[] = ${JSON.stringify(orgChart.people, null, 2).replace(/"(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)"/g, 'new Date("$1")')};

export const defaultOrgChartData: OrgChartData = {
 people: initialOrgChartData,
 lastModified: new Date()
};`;

  const blob = new Blob([orgChartDataContent], { type: 'text/typescript' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'orgChartData.ts';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  alert(`Org Chart data exported successfully!

 Changes are now saved and will persist across browsers and refreshes!

Instructions to make permanent (optional):
1. Replace the contents of src/data/orgChartData.ts with the downloaded file
2. Commit and push the changes to update the deployed version

File downloaded: orgChartData.ts`);
 };


 return (
  <div className="flex flex-col h-screen bg-white">
   {/* Simple Header */}
   <div className="flex-none border-b border-gray-200 p-2 sm:p-4">
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
     <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      {/* Navigation Toggle */}
      <div className="flex bg-gray-100 rounded-lg p-1 self-start">
       <button
        onClick={() => setCurrentView('scorecard')}
        className={`px-3 py-2 text-xs sm:text-sm font-medium rounded-md transition-colors ${currentView === 'scorecard'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
         }`}
       >
        Scorecard
       </button>
       <button
        onClick={() => setCurrentView('orgchart')}
        className={`px-3 py-2 text-xs sm:text-sm font-medium rounded-md transition-colors ${currentView === 'orgchart'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
         }`}
       >
        Org Chart
       </button>
       <button
        onClick={() => setCurrentView('gap')}
        className={`px-3 py-2 text-xs sm:text-sm font-medium rounded-md transition-colors ${currentView === 'gap'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
         }`}
       >
        Gap
       </button>
      </div>
      <h1 className="text-lg sm:text-xl font-bold text-gray-900">
       {currentView === 'scorecard' ? 'Cardiovolt Scorecard' : currentView === 'orgchart' ? 'Organization Chart' : 'Gap Analysis'}
      </h1>
     </div>
     <div className="flex flex-wrap items-center gap-2">
      {currentView === 'orgchart' && isAdmin && (
       <button
        onClick={() => exportOrgChartData()}
        className="bg-gradient-to-r from-cardio-500 to-cardio-600 hover:from-cardio-600 hover:to-cardio-700 text-white px-2 py-1 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
       >
         Save
       </button>
      )}
      <button
       onClick={logout}
       className="text-xs sm:text-sm text-gray-600 hover:text-gray-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
      >
       Logout
      </button>
     </div>
    </div>
   </div>

   {/* Content Area */}
   {currentView === 'scorecard' ? (
    <HierarchicalScorecard />
   ) : currentView === 'orgchart' ? (
    /* Org Chart View */
    <OrgChart />
   ) : (
    /* Gap Analysis View */
    <GapDashboard />
   )}
  </div>
 );
}